// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCouponWholeOrderType_wrapper__Foy5Q","blockTitle":"EditCouponWholeOrderType_blockTitle__PNuGY","smallPadding":"EditCouponWholeOrderType_smallPadding__OQp2b"};